module.exports = __webpack_public_path__ + "img/niupai.0639ba8c.png";